import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface IDateForNotification {
    title: string,
    type: "success" | "error" | "warning" | null,
    description?: string
}

interface IDateForLoginPopup {
    isOpen: boolean,
    redirectPath?: string
}

interface IInitialState {
    message: IDateForNotification,
    loginPopup: IDateForLoginPopup
}

const initialState: IInitialState = {
    message: {
        type: null,
        description: "",
        title: ""
    },
    loginPopup: {
        isOpen: false,
        redirectPath: ""
    }
}

export const notificationsSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        openMessage(state, action: PayloadAction<IDateForNotification>) {
            state.message = action.payload;
        },
        closeMessage(state) {
            state.message = initialState.message;
        },
        openLoginPopup(state, action: PayloadAction<IDateForLoginPopup>) {
            state.loginPopup = action.payload;
        },
        closeLoginPopup(state) {
            state.loginPopup = initialState.loginPopup;
        }
    }
})

export const {openMessage, closeMessage, closeLoginPopup, openLoginPopup} = notificationsSlice.actions;

export default notificationsSlice.reducer;